import React from 'react';
import { ClipLoader } from 'react-spinners';
import './style.scss';

const Index = () => {
    return (
        <span className='ew-mst-loader'>
            <ClipLoader />
        </span>
    )
};

export default Index;